<template>
  <div class="info-detail-root">
    <el-form ref="refForm" :model="formData">
      <div
        v-if="formData.gridList && formData.gridList.length > 0"
        class="v-grid-list"
      >
        <div
          class="block-item"
          v-for="(bigItem, bigIndex) in formData.gridList
            ? formData.gridList
            : []"
          :key="bigIndex"
        >
          <!-- 标题层 -->
          <div class="top-title">
            <div class="full-title">
              <div class="big-title">
                <span class="weight" v-show="bigItem.isMust">*</span>
                <span class="txt">{{ bigItem.title }}</span>
                <el-tooltip
                  placement="top"
                  v-if="getBeChangeImagesTip(bigItem.changeList)"
                >
                  <div slot="content">
                    <div style="margin-bottom: 10px">变更前：</div>
                    <div
                      v-if="!getBeChangeImagesTip(bigItem.changeList).length"
                    >
                      无
                    </div>
                    <el-image
                      v-for="(item, index) in getBeChangeImagesTip(
                        bigItem.changeList
                      )"
                      :key="index"
                      :src="item"
                      style="height: 120px; width: 120px"
                      :preview-src-list="
                        getBeChangeImagesTip(bigItem.changeList)
                      "
                    />
                  </div>
                  <i class="el-icon-warning" style="color: #ffbf04"></i>
                </el-tooltip>
              </div>
              <div class="btn-layout">
                <el-button
                  v-if="bigItem.template"
                  type="text"
                  @click="handleDownTemplate(bigItem.template)"
                  >下载模板</el-button
                >
                <el-button
                  v-if="bigItem.example"
                  type="text"
                  @click="handleLookSample(bigItem.example)"
                  >查看示例
                </el-button>
              </div>
            </div>
            <div class="remarks">
              {{ bigItem.description || "" }}
            </div>
          </div>
          <div class="content-layout">
            <el-form-item
              :prop="'gridList.' + bigIndex + '.imageUrlList'"
              :rules="[
                {
                  required: bigItem.isMust,
                  message: '请上传至少一张图片',
                  trigger: 'blur',
                },
              ]"
            >
              <!-- 图片层 -->
              <div class="pic-layout">
                <div
                  class="item"
                  v-for="(item, index) in bigItem.imageUrlList
                    ? bigItem.imageUrlList
                    : []"
                  :key="index"
                >
                  <el-image
                    :ref="`myImgB${bigIndex}S${index}`"
                    :src="item"
                    fit="cover"
                    class="icon"
                    :initial-index="index"
                    :preview-src-list="bigItem.imageUrlList"
                  />
                  <div class="preview">
                    <el-image
                      @click="clickImg(item, bigIndex)"
                      :src="SeeIcon"
                      class="btn-icon"
                    />
                    <el-image
                      v-if="!disabled"
                      @click="handleDeleteImage(bigIndex, index)"
                      :src="DelIcon"
                      class="btn-icon"
                    />
                  </div>
                </div>
                <div
                  class="item add-pic"
                  v-if="!hideAddPicBtn(bigItem)"
                  @click="handleUpload(bigIndex)"
                >
                  <div class="image-wrap">
                    <el-image :src="AddIcon" />
                  </div>
                  <span class="text">上传照片</span>
                </div>
              </div>
            </el-form-item>
            <!-- 动态Filed -->
            <div class="input-layout">
              <div
                :class="{
                  'input-item': true,
                  'fill-wrap':
                    bigItem.filedList.length % 2 !== 0 &&
                    subIndex === bigItem.filedList.length - 1,
                }"
                v-for="(subItem, subIndex) in bigItem.filedList"
                :key="subIndex"
              >
                <el-form-item
                  :prop="
                    'gridList.' +
                    bigIndex +
                    '.filedList.' +
                    subIndex +
                    '.modeValue'
                  "
                  :rules="[
                    {
                      required: subItem.isMust,
                      message: '值不能为空',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <DynamicFiled
                    :type="subItem.type"
                    :disabled="disabled"
                    v-model="subItem.modeValue"
                    :data-item="subItem"
                  />
                </el-form-item>
              </div>
              <div>
                <div class="big-title mgb-10">
                  <span class="txt">有效期</span>
                  <el-tooltip
                    placement="top"
                    v-if="
                      bigItem &&
                      bigItem.changeList.length &&
                      getBechangeEndValidDate(bigItem.changeList).length > 0
                    "
                  >
                    <div slot="content">
                      <div style="margin-bottom: 10px">变更前：</div>
                      <div>
                        {{ getBechangeEndValidDate(bigItem.changeList) }}
                      </div>
                    </div>
                    <i class="el-icon-warning" style="color: #ffbf04"></i>
                  </el-tooltip>
                </div>
                <el-form-item>
                  <!-- <el-date-picker
                    v-model="bigItem.periodValidity"
                    :disabled="type == 'view'"
                    type="daterange"
                    size="mini"
                    style="margin-top: 10px; width: 100%"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker> -->
                  <el-date-picker
                    :disabled="type == 'view'"
                    v-model="bigItem.periodValidity[1]"
                    type="date"
                    placeholder="有效期至"
                    :clearable="false"
                    :picker-options="{
                      disabledDate: (time) => time.getTime() < Date.now(),
                    }"
                    @change="
                      (value) => {
                        changeDate(value, bigIndex);
                      }
                    "
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-radio-group
                    v-model="bigItem.termType"
                    style="margin-top: 10px"
                    :disabled="type == 'view'"
                    @change="
                      (value) => {
                        changePeriod(value, bigIndex);
                      }
                    "
                  >
                    <el-radio :label="2">本年底</el-radio>
                    <!-- <el-radio :label="3">3年</el-radio>
                    <el-radio :label="4">4年</el-radio>
                    <el-radio :label="5">5年</el-radio>
                    <el-radio :label="6">10年</el-radio> -->
                    <el-radio :label="1">长期</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bottom-dynamic-filed">
        <div
          class="input-layout"
          v-if="formData.filedList && formData.filedList.length > 0"
        >
          <div
            :class="{
              'input-item': true,
            }"
            v-for="(item, index) in formData.filedList"
            :key="index"
          >
            <el-form-item
              :prop="'filedList.' + index + '.modeValue'"
              :rules="[
                {
                  required: item.isMust,
                  message: '值不能为空',
                  trigger: 'blur',
                },
              ]"
            >
              <DynamicFiled
                :type="item.type"
                :disabled="disabled"
                v-model="item.modeValue"
                :data-item="item"
              />
            </el-form-item>
          </div>
        </div>
        <div>
          <!-- <el-form-item required label="经营范围：">
            <el-tooltip :content="'getBeChangeTip'" placement="top">
              <i class="el-icon-warning" style="color: #ffbf04"></i>
            </el-tooltip>
          </el-form-item> -->
          <div class="big-title mgt-20">
            <span class="weight">*</span>
            <span class="txt">经营范围</span>
            <el-tooltip placement="top" v-if="scopesChangeInfo">
              <div slot="content">
                <div style="margin-bottom: 10px">变更前：</div>
                <div>{{ scopesChangeInfo }}</div>
              </div>
              <i class="el-icon-warning" style="color: #ffbf04"></i>
            </el-tooltip>
          </div>
          <el-checkbox-group
            :disabled="type == 'view'"
            v-model="formData.checkList"
            style="margin-top: 10px"
          >
            <el-checkbox
              v-for="item in rangeList"
              :label="item.value"
              :key="item.value"
              :disabled="item.disabled"
            >
              {{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </el-form>

    <!-- <div class="bottom-btn-layout" v-if="!disabled">
      <el-button @click="handlePreStep">上一步</el-button>
      <el-button @click="handleSaveDraft" v-if="showDraftBtn"
        >保存草稿</el-button
      >
      <el-button type="danger" @click="handleSubmit">提 交</el-button>
    </div> -->

    <UploadImageView
      ref="imgupload"
      request-id="1"
      :imgType="imgType"
      @upload="uploadSubmit"
    />

    <div
      style="
        width: 34%;
        height: 100%;
        position: fixed;
        overflow: hidden;
        left: 0;
        top: 0px;
        z-index: 1031;
      "
      id="jinbiao"
      ref="jinbiao"
      @mouseenter="zoomEnable = true"
      @mouseleave="zoomEnable = false"
      v-if="dialogDiv"
    >
      <div
        id="mouseenterDiv"
        v-if="dialogDiv"
        @mouseenter="mouseenter"
        style="
          width: 10px;
          cursor: move;
          position: absolute;
          right: 0px;
          top: 0px;
          height: 100%;
          z-index: 2500;
        "
      ></div>
      <imageViewer
        v-if="showViewer"
        id="imageViewer"
        style="overflow: hidden; box-shadow: 2px #fafafa"
        :initialIndex="initialIndex"
        :zoomEnable="zoomEnable"
        ref="imageViewer"
        :append-to-body="false"
        :on-close="closeViewer"
        :on-edit="editView"
        :onSwitch="onSwitch"
        :url-list="src"
      />
    </div>

    <el-dialog
      title="裁剪"
      :visible.sync="cropDialogVisible"
      :fullscreen="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeDialog"
      center
    >
      <Croper :imgUrl="cropUrl" @editImageSuccess="editImageSuccess" />
    </el-dialog>
  </div>
</template>

<script>
import imageViewer from "./imageViewer.vue";
import dayjs from "dayjs";
import DynamicFiled from "../components/dynamicFiled.vue";
//该组件是复制 @/views/merchantsettlement/myupload.vue，因为这里的代码会被复制到 大商场共同使用
import UploadImageView from "../components/UploadImage.vue";
import Croper from "@/components/cropper";
import _ from "lodash";
const IConst_See_Icon = require("@/assets/zz/see-icon.png");
const IConst_Del_Icon = require("@/assets/zz/del-icon.png");
const IConst_Add_Icon = require("@/assets/zz/add-icon.png");

import {
  getCertifyDetail,
  doTmpSaveCertify,
  doCommitCertify,
} from "@/api/myQualification/index";

import { viewHelp, IConst_State } from "../util/ViewHelp";

export default {
  components: { DynamicFiled, UploadImageView, imageViewer, Croper },
  props: {
    disabled: {
      type: Boolean,
      default: () => false,
    },
    type: {
      default: "approve",
    },
    infoDetailData: {
      type: Object,
      default: () => {},
    },
    queryScopeListData: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    infoDetailData: {
      immediate: true,
      handler: function (val) {
        // if (val && val.id) {
        this.transServiceDataToFormData(val);
        // }
      },
    },
    queryScopeListData: {
      immediate: true,
      handler: function (val) {
        if (val && val.length > 0) {
          this.rangeList = val.map((item) => {
            return {
              value: item.id,
              label: item.name,
              disabled: item.name == '中药材' || item.name == '生化药品',
            };
          });
        }
      },
    },
  },
  data() {
    return {
      src: [],
      initialIndex: 0,
      dialogDiv: false,
      showViewer: false,
      zoomEnable: false,
      //图片预览

      IConst_State: IConst_State,

      SeeIcon: IConst_See_Icon,
      DelIcon: IConst_Del_Icon,
      AddIcon: IConst_Add_Icon,

      showImageViewer: false,
      previewUrls: null,

      imgType: "",
      IConst_Max_Pic_Count: 5,
      rangeList: [],
      formData: {
        //底部的动态域字段
        filedList: [
          // {
          //   type: 1,
          //   tip: "测试1",
          //   modeValue: "x",
          //   isMust: false,
          //   modeValueName: "",
          // },
          // { type: 2, tip: "测试", modeValue: "key1", isMust: false },
          // { type: 3, tip: "测试", modeValue: ["key2"], isMust: true },
          // {
          //   type: 4,
          //   tip: "测试2",
          //   modeValue: [130000, 130200, 130202],
          //   isMust: false,
          // },
        ],

        gridList: [],

        // 经营范围
        checkList: [],
      },
      currentBigIndex: -1, //当前资质图片 gridList索引
      cropDialogVisible: false,
      cropUrl: "",
      scopesChangeInfo: "", //经营范围变更信息
    };
  },
  computed: {
    status() {
      const status = this.$store.state.qualification?.detail
        ? this.$store.state.qualification.detail.status
        : "";
      return status;
    },
    showDraftBtn() {
      return this.status === this.IConst_State.None || this.status === "";
    },
  },
  created() {
    // if (!this.$store.state.qualification.detail) {
    // this.doLoadCertifyDetail();
    // } else {
    //   this.formData = viewHelp.assistQualificationDetail(
    //     this.$store.state.qualification.detail
    //   );
    // }
  },
  methods: {
    getBeChangeImagesTip(list) {
      if (list && list.length > 0) {
        const findCertificateImages = list.find((item) => {
          return item.change == "certificateImages";
        });
        if (findCertificateImages) {
          return findCertificateImages.changeContent;
        }
        return null;
      }
      return null;
    },
    getBechangeEndValidDate(list) {
      if (list && list.length > 0) {
        const certificateImagesInfo = list.filter((item) => {
          return item.change == "endValidDate";
        });
        const str =
          certificateImagesInfo && certificateImagesInfo.length > 0
            ? certificateImagesInfo[0].changeContent
            : "";
        return str;
      }
      return "";
    },
    closeDialog() {
      this.cropUrl = "";
      this.cropDialogVisible = false;
    },
    editImageSuccess(oldImage, newImage) {
      // const
      let oldList = _.cloneDeep(this.formData.gridList);
      let oldSrc = _.cloneDeep(this.src);
      oldList.forEach((item) => {
        if (item.imageUrlList.length > 0) {
          const index = _.findIndex(item.imageUrlList, (v) => {
            return v == oldImage;
          });
          if (index >= 0) {
            item.imageUrlList[index] = newImage;
            const srcIndex = _.findIndex(oldSrc, (v) => {
              return v == oldImage;
            });
            if (srcIndex >= 0) {
              oldSrc[srcIndex] = newImage;
            }
          }
        }
      });
      this.formData.gridList = oldList;
      this.src = oldSrc;
      this.cropUrl = "";
      this.cropDialogVisible = false;
    },
    // 关闭图片弹窗
    closeViewer() {
      this.showViewer = false;
      this.dialogDiv = false;
    },
    editView() {
      this.cropUrl = this.src[this.initialIndex];
      this.cropDialogVisible = true;
    },
    onSwitch(index) {
      this.initialIndex = index;
    },
    // 点击图片
    clickImg(li, index) {
      this.showViewer = false;
      this.dialogDiv = false;
      this.dialogDiv = true;
      this.initialIndex = this.src.findIndex((item) => {
        return item == li;
      });
      this.$nextTick(() => {
        const v = document.getElementById("jinbiao");
        v.style.setProperty("width", "34%", "important");
        this.showViewer = true;
        this.$nextTick(() => {
          const c = document.getElementById("imageViewer");
          c.style.setProperty("width", "34%");
        });
      });
    },
    // 鼠标进入
    mouseenter() {
      const v = document.getElementById("jinbiao");
      const c = document.getElementById("imageViewer");
      const mouseenterDiv = document.getElementById("mouseenterDiv");
      mouseenterDiv.onmousedown = function (e) {
        document.onmousemove = function (e) {
          v.style.setProperty("width", e.x + "px", "important");
          c.style.setProperty("width", e.x + "px", "important");
        };
        // 鼠标松开事件
        document.onmouseup = function (evt) {
          document.onmousemove = null;
          document.onmouseup = null;
          // v.releaseCapture && v.releaseCapture();
        };
        // v.setCapture && v.setCapture();
      };
    },
    changeDate(value, index) {
      if (!value) {
        return;
      }
      // this.formData.gridList[index].termType = ''
      this.formData.gridList[index].periodValidity[0] =
        dayjs().format("YYYY-MM-DD");
      this.formData.gridList[index].periodValidity[1] =
        dayjs(value).format("YYYY-MM-DD");
    },
    changePeriod(value, index) {
      if (value == 1) {
        this.formData.gridList[index].periodValidity[0] =
          dayjs().format("YYYY-MM-DD");
        this.formData.gridList[index].periodValidity[1] = dayjs()
          .add(999, "year")
          .format("YYYY-MM-DD");
        // this.formData.gridList[index].endValidDate = dayjs().add(999, "year").format("YYYY-MM-DD")
      }
      if (value == 2) {
        this.formData.gridList[index].periodValidity[0] =
          dayjs().format("YYYY-MM-DD");
        this.formData.gridList[index].periodValidity[1] =
          dayjs().format("YYYY-12-31");
        // this.formData.gridList[index].endValidDate = dayjs().format("YYYY-12-31");
      }
      // if (value == 3) {
      //   this.formData.gridList[index].periodValidity[0] =
      //     dayjs().format("YYYY-MM-DD");
      //   this.formData.gridList[index].periodValidity[1] = dayjs()
      //     .add(3, "year")
      //     .format("YYYY-MM-DD");
      // }
      // if (value == 4) {
      //   this.formData.gridList[index].periodValidity[0] =
      //     dayjs().format("YYYY-MM-DD");
      //   this.formData.gridList[index].periodValidity[1] = dayjs()
      //     .add(4, "year")
      //     .format("YYYY-MM-DD");
      // }
      // if (value == 5) {
      //   this.formData.gridList[index].periodValidity[0] =
      //     dayjs().format("YYYY-MM-DD");
      //   this.formData.gridList[index].periodValidity[1] = dayjs()
      //     .add(6, "year")
      //     .format("YYYY-MM-DD");
      // }
      // if (value == 6) {
      //   this.formData.gridList[index].periodValidity[0] =
      //     dayjs().format("YYYY-MM-DD");
      //   this.formData.gridList[index].periodValidity[1] = dayjs()
      //     .add(10, "year")
      //     .format("YYYY-MM-DD");
      // }
      this.formData = JSON.parse(JSON.stringify(this.formData));
    },
    handleDownTemplate(fileUrl) {
      window.open(fileUrl);
    },
    handleLookSample(fileUrl) {
      if (fileUrl && fileUrl.indexOf("pdf") > -1) {
        window.open(fileUrl, "_blank");
      } else {
        this.urls = [fileUrl];
        this.showViewer = true;
      }
    },
    handlePreview(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName][0].showViewer = true;
      }
    },
    handleDeleteImage(bigIndex, samllIndex) {
      const smallItem = this.formData.gridList[bigIndex].imageUrlList;
      smallItem.splice(samllIndex, 1);
    },
    hideAddPicBtn(bigItem) {
      return (
        this.disabled ||
        (bigItem.imageUrlList &&
          bigItem.imageUrlList instanceof Array &&
          bigItem.imageUrlList.length >= this.IConst_Max_Pic_Count)
      );
    },
    getFormData() {
      let validForm = false;
      this.$refs.refForm.validate((valid, fields) => {
        validForm = valid;
      });
      if (validForm) {
        return this.formData;
      }
    },
    uploadSubmit(obj) {
      const { type, url } = obj;
      const bigItem = this.formData.gridList[this.currentBigIndex];
      bigItem.imageUrlList.push(url);
      this.src.push(url);
    },

    handlePreStep() {
      this.$emit("pre-step");
    },
    handleSubmit() {
      this.$refs.refForm.validate((valid, fields) => {
        if (valid) {
          this.doSaveCommit();
        } else {
          //
        }
      });
    },

    transServiceDataToFormData(val) {
      if (val && val.certifyList) {
        this.formData.gridList = val.certifyList.map((cert) => {
          return {
            ...cert,
            termType: Number(cert.termType),
            title: cert.certificateName,
            isMust: Boolean(cert.required),
            imageUrlList: cert.certificateImages || [],
            example: cert.example,
            template: cert.template,
            periodValidity: [cert.startValidDate, cert.endValidDate || ""],
            changeList: cert.changeList || [],
            filedList:
              cert.fields &&
              cert.fields.map((item) => {
                return {
                  ...item,
                  type: item.inputType,
                  tip: item.fieldNameText,
                  modeValue: item.fieldValue,
                  isMust: item.required || false,
                  certificateId: item.certificateId,
                  options: this.transSelectEnumToOptions(item.selectEnum),
                };
              }),
          };
        });
      }
      if (val && val.commonFieldList) {
        this.formData.filedList = val.commonFieldList.map((com) => {
          return {
            ...com,
            type: com.inputType,
            tip: com.fieldNameText,
            modeValue: com.fieldValue,
            isMust: Boolean(com.required),
            options: this.transSelectEnumToOptions(com.selectEnum),
            beChange: Boolean(com.beChange),
            changeContent: com.changeContent,
          };
        });
      }
      if (val && val.id) {
        this.formData.id = val.id;
        this.formData.status = val.status;
        this.formData.requestId = val.requestId;
        this.formData.checkList = val.scopes;
      }
      if (this.formData) {
        this.formData.gridList.forEach((item) => {
          let imgs = [];
          if (item.imageUrlList.length > 0) {
            item.imageUrlList.forEach((el) => {
              imgs.push(el);
            });
          }
          this.src = this.src.concat(imgs);
        });
      }
      // 检查经营范围的修改情况（每次重新计算前先清空，避免保存后旧数据残留导致感叹号不消失）
      this.scopesChangeInfo = "";
      if (val && val.changeList && val.changeList.length > 0) {
        const scopesChange = val.changeList.find((item) => {
          return item.change === "scopes";
        });
        if (scopesChange) {
          this.scopesChangeInfo = scopesChange.changeContent;
        }
      }
    },
    transSelectEnumToOptions(selectEnum) {
      let options = [];
      if (selectEnum) {
        try {
          const objValue = JSON.parse(selectEnum);
          Object.keys(objValue).forEach((key) => {
            options.push({
              label: objValue[key],
              value: key,
            });
          });
        } catch (error) {}
      }
      return options;
    },
    handleUpload(bigIndex) {
      this.currentBigIndex = bigIndex;
      this.$refs["imgupload"].open(this.imgType);
    },
    doLoadCertifyDetail(nextStep) {
      const params = { typeCode: 1 };
      // const selectedCompanyTypes =
      //   this.$store.state.qualification.selectedCompanyTypes;
      // if (
      //   selectedCompanyTypes &&
      //   selectedCompanyTypes instanceof Array &&
      //   selectedCompanyTypes.length > 0
      // ) {
      //   params.typeCode = selectedCompanyTypes
      //     .map((item) => item.typeCode)
      //     .join(",");
      // }

      getCertifyDetail(params).then((res) => {
        if (res.code == 0) {
          if (res.data) {
            const shopDetail = res.data;
            this.$store.dispatch(
              "qualification/setDetail",
              _.cloneDeep(shopDetail)
            );
            if (nextStep) {
              //进入下一步,应该就是提交
              this.$emit("submit");
            } else {
              this.formData = viewHelp.assistQualificationDetail(res.data);
            }
          }
        } else {
          viewHelp.showErrorMsg(this.$message, res);
        }
      });
    },
    // doSaveDraft() {
    //   //保存草稿
    //   const serveData = viewHelp.generateServeData(this.formData);

    //   let typeCode = "";
    //   if (this.$store.state.qualification.selectedCompanyTypes) {
    //     const typeCodeArr =
    //       this.$store.state.qualification.selectedCompanyTypes.map(
    //         (item) => item.typeCode
    //       );
    //     typeCode = typeCodeArr.join(",");
    //   }
    //   const data = { ...serveData, shopTypeCode: typeCode };

    //   doTmpSaveCertify(data).then((res) => {
    //     if (res.code === 0) {
    //       this.doLoadCertifyDetail();
    //       viewHelp.showSuccessMsg(this.$message, "保存草稿成功");
    //     } else {
    //       viewHelp.showErrorMsg(this.$message, res);
    //     }
    //   });
    //   //
    // },
    doSaveCommit() {
      //修改或提交
      const serveData = viewHelp.generateServeData(this.formData);

      let typeCode = "";
      if (this.$store.state.qualification.selectedCompanyTypes) {
        const typeCodeArr =
          this.$store.state.qualification.selectedCompanyTypes.map(
            (item) => item.typeCode
          );
        typeCode = typeCodeArr.join(",");
      }
      const data = { ...serveData, shopTypeCode: typeCode };

      doCommitCertify(data).then((res) => {
        if (res.code === 0) {
          this.doLoadCertifyDetail(true);
        } else {
          viewHelp.showErrorMsg(this.$message, res);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.info-detail-root {
  width: 100%;
  margin: 0 12px;
  --border-line-color: #d9d9d9;

  display: flex;
  flex-direction: column;
}

.v-grid-list {
  padding-bottom: 8px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--border-line-color);
  // display: grid;
  // grid-template-columns: repeat(2, 1fr);

  // column-count: 2;
  // column-width: 494px; /* 每列每个元素最小的宽度 */
  // column-gap: 24px; /* 每列的距离，不设置这个可以通过margin来设置边距 */
}

/**瀑布块 */
.block-item {
  display: block;
  --btn-focus-color: #cf1422;

  flex-shrink: 0;
  width: 100%; //固定宽度
  background: #ffffff;
  border: 1px solid var(--border-line-color);
  border-radius: 4px;

  margin-bottom: 24px;
  margin-right: 0;

  .top-title {
    display: flex;
    flex-direction: column;
    padding: 12px 16px 12px 8px;
    border-bottom: 1px solid var(--border-line-color);

    .full-title {
      display: flex;
      align-items: center;

      box-sizing: border-box;
      justify-content: space-between;
    }

    .btn-layout {
      .el-button--text {
        color: var(--btn-focus-color);
      }
      ::v-deep .el-button {
        padding: 0;

        + .el-button {
          margin-left: 16px;
        }
      }
    }

    .remarks {
      padding-left: 8px;
      box-sizing: border-box;
      font-size: 14px;
      font-weight: 400;
      color: #8c8c8c;
      margin-top: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .content-layout {
    padding: 0;
    box-sizing: border-box;
    display: flex;
    position: relative;

    ::v-deep .el-form-item {
      flex: 1;
      .el-form-item__content {
        width: 100%;
      }
    }
    .pic-layout {
      display: flex;
      width: 100%;
      padding: 16px;
      .item {
        width: 86px;
        height: 86px;
        background: #ffffff;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        position: relative;
        overflow: hidden;

        & + .item {
          margin-left: 8px;
        }

        .icon {
          position: relative;
          width: 100%;
          height: 100%;
        }

        .preview {
          position: absolute;
          visibility: hidden;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          opacity: 0.5;
          background: #000000;
          display: flex;
          align-items: center;
          justify-content: center;

          .btn-icon {
            width: 16px;
            height: 16px;
            cursor: pointer;
            & + .btn-icon {
              margin-left: 8px;
            }
          }
        }

        &:hover {
          .preview {
            visibility: visible;
          }
        }

        &.add-pic {
          border: 1px dashed #d9d9d9;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          .image-wrap {
            border: 1px dashed #d9d9d9;
            width: 20px;
            height: 20px;

            & > * {
              width: 100%;
              height: 100%;
            }
          }

          .text {
            font-size: 14px;
            font-weight: 400;
            color: #595959;
            margin-top: 8px;
          }
        }
      }
    }

    .input-layout {
      display: flex;
      flex-wrap: wrap;
      padding-top: 8px;
      box-sizing: border-box;
      width: 440px;
      flex-shrink: 0;
      padding: 16px;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 1px;
        height: 100%;
        background: var(--border-line-color);
      }

      .input-item {
        margin-top: 8px;
        width: 100%;

        // &:nth-child(2n) {
        //   margin-left: 8px;
        // }

        &.fill-wrap {
          width: 100%;
        }
      }
    }
  }
}

/**底部动态域 */
.bottom-dynamic-filed {
  display: flex;
  flex-wrap: wrap;
  padding-top: 24px;
  padding-bottom: 32px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--border-line-color);

  .input-layout {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    box-sizing: border-box;

    .input-item {
      margin-top: 8px;
      width: calc(33.33333% - 6px);

      &:nth-child(3n + 2),
      &:nth-child(3n) {
        margin-left: 8px;
      }

      &.fill-wrap {
        width: 100%;
      }
    }
  }
}

/**按钮层 */
.bottom-btn-layout {
  display: flex;
  justify-content: center;
  margin-top: 32px;

  ::v-deep .el-button {
    width: 120px;

    & + .el-button {
      margin-left: 12px;
    }
  }

  ::v-deep .el-button--danger {
    background-color: #f5222d;
    border-color: #f5222d;

    &:hover {
      background: #f78989;
      border-color: #f78989;
    }
  }
}

/**el-form */
.el-form {
  .el-form-item {
    margin: 0 !important;
    padding: 0;
    box-sizing: border-box;
  }
}

::v-deep .el-form-item__content {
  line-height: inherit;

  .el-form-item__error {
    padding-top: 0px;
  }
}
.big-title {
  display: flex;
  align-items: center;
  .weight {
    width: 8px;
    height: 22px;
    font-size: 14px;
    font-weight: 400;
    color: #f6212d;
    line-height: 22px;
    position: relative;
    top: 2px;
  }
  .txt {
    font-size: 14px;
    font-weight: 600;
    color: #262626;
  }
}
.mgt-20 {
  margin-top: 20px;
}
.mgb-10 {
  margin: 10px 0px;
}
</style>
